__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "reporter-admin";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/animations/fesm2022/animations.mjs */ 7172))), 1);
			register("@angular/common/http", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/http.mjs */ 6443))), 1);
			register("@angular/common", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2022/common.mjs */ 316))), 1);
			register("@angular/core", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2022/core.mjs */ 7580))), 1);
			register("@angular/forms", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/forms/fesm2022/forms.mjs */ 4456))), 1);
			register("@angular/router", "20.3.35", () => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2022/router.mjs */ 5072))), 1);
			register("@auth0/angular-jwt", "5.2.0", () => (() => (__webpack_require__(/*! ./node_modules/@auth0/angular-jwt/fesm2020/auth0-angular-jwt.mjs */ 2389))), 1);
			register("@gbgofc/common", "latest", () => (() => (__webpack_require__(/*! ./node_modules/@gbgofc/common/fesm2022/gbgofc-common.mjs */ 7217))), 1);
			register("ngx-infinite-scroll", "20.0.0", () => (() => (__webpack_require__(/*! ./node_modules/ngx-infinite-scroll/fesm2022/ngx-infinite-scroll.mjs */ 6739))), 1);
			register("ngx-toastr", "19.1.0", () => (() => (__webpack_require__(/*! ./node_modules/ngx-toastr/fesm2022/ngx-toastr.mjs */ 4285))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};